module.exports = __webpack_public_path__ + "static/mythbusting-a91285d9ef53db23858cfde4aec4e480.png";